import Bar from "./Bar";
import Line from "./Line";
import Pie from "./Pie";

const Charts = {
  Bar,
  Line,
  Pie,
};

export default Charts;
